import { Amplify } from "aws-amplify";
import { amplifyAppSyncConfig } from "./appsync";
import { amplifyConfig as cognitoConfig } from "./cognito";

// Type for the merged Amplify configuration
type AmplifyConfigType = typeof cognitoConfig & {
  API?: {
    GraphQL: {
      endpoint: string;
      region: string;
      defaultAuthMode: "userPool";
    };
  };
};

// Merge all Amplify configurations into a single config object
// This ensures Auth and API configurations are set together
const mergedConfig: AmplifyConfigType = {
  ...cognitoConfig,
};

// Only include AppSync/GraphQL config if endpoint is provided
if (amplifyAppSyncConfig.GraphQL.endpoint) {
  mergedConfig.API = {
    GraphQL: amplifyAppSyncConfig.GraphQL,
  };
}

export const amplifyConfig = mergedConfig;

// Configure Amplify once with the merged configuration
// This should be called before any Amplify operations
let isConfigured = false;

export const configureAmplify = () => {
  if (isConfigured) {
    console.warn("Amplify is already configured. Skipping reconfiguration.");
    return;
  }

  Amplify.configure(amplifyConfig);
  isConfigured = true;
  console.log("Amplify configured successfully");
};

// Auto-configure on module load to ensure it happens early
if (typeof window !== "undefined") {
  configureAmplify();
}
